import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import { useState } from 'react';
import { NotificacaoService } from '../../services/api/notificacao/NotificacaoService';
import DeleteIcon from '@mui/icons-material/Delete';

interface NotificationTableProps {
    notifications: any[];
}

const parametroMap: { [key: string]: string } = {
    precipitationSum: 'Precipitação (mm)',
    // humidityMax: 'Umidade Máx. (%)',
    // humidityMin: 'Umidade Mín. (%)',
    // temperatureMax: 'Temperatura Máx. (°C)',
    // temperatureMin: 'Temperatura Mín. (°C)',
    // windSpeedMax: 'Vento Máx. (Km/h)',
};

const comparadorMap: { [key: string]: string } = {
    '<': 'Menor que (<)',
    '>': 'Maior que (>)',
    '<=': 'Menor ou igual a (<=)',
    '>=': 'Maior ou igual a (>=)',
    '==': 'Igual a (==)',
    '!=': 'Diferente de (!=)',
};

interface NotificationTableProps {
    notifications: any[];
    onDeleteSuccess: () => void;
}

export default function NotificationTable({ notifications, onDeleteSuccess }: NotificationTableProps) {
    const [openDialog, setOpenDialog] = useState(false);
    const [notificationToDelete, setNotificationToDelete] = useState<string | null>(null);

    const handleOpenDialog = (uuid: string) => {
        setNotificationToDelete(uuid);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setNotificationToDelete(null);
    };

    const handleDelete = async () => {
        if (notificationToDelete) {
            try {
                await NotificacaoService.deleteNotification(notificationToDelete);
                handleCloseDialog();
                onDeleteSuccess();
            } catch (error) {
                console.error('Erro ao deletar notificação:', error);
                handleCloseDialog();
            }
        }
    };

    if (!notifications || notifications.length === 0) {
        return (
            <Box sx={{ paddingY: '1rem' }}>
                <Typography variant="body1" color="text.secondary">
                    Nenhuma notificação configurada para esta barragem.
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer component={Paper} sx={{ boxShadow: 'initial' }}>
            <Table aria-label="tabela de notificações">
                <TableHead>
                    <TableRow>
                        <TableCell>Parâmetro</TableCell>
                        <TableCell align="right">Comparador</TableCell>
                        <TableCell align="right">Valor</TableCell>
                        <TableCell align="right">Data de Criação</TableCell>
                        <TableCell align="right">Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notifications.map((notificacao) => (
                        <TableRow key={notificacao.uuid}>
                            <TableCell component="th" scope="row">
                                {parametroMap[notificacao.parametro] || notificacao.parametro}
                            </TableCell>
                            <TableCell align="right">
                                {comparadorMap[notificacao.comparador] || notificacao.comparador}
                            </TableCell>
                            <TableCell align="right">{notificacao.valor}</TableCell>
                            <TableCell align="right">
                                {new Date(notificacao.createdAt).toLocaleDateString('pt-BR')}
                            </TableCell>
                            <TableCell align="right">
                                <IconButton
                                    aria-label="delete"
                                    color="error"
                                    onClick={() => handleOpenDialog(notificacao.uuid)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem certeza que deseja deletar esta notificação? Esta ação é irreversível.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleDelete} color="error" variant="contained" autoFocus>
                        Deletar
                    </Button>
                </DialogActions>
            </Dialog>
        </TableContainer>
    );
}